export interface FAQ {
  id: string;
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    id: 'faq-1',
    question: '黄瓜种植什么季节最好？',
    answer: '黄瓜喜温怕寒，最适宜的生长温度为25-30℃。春季大棚栽培一般在2-3月份育苗，3-4月份定植；秋季大棚栽培在7-8月份育苗，8-9月份定植；露地栽培需在终霜后进行，一般在4-5月份直播或定植。不同地区根据当地气候条件适当调整播期。',
  },
  {
    id: 'faq-2',
    question: '黄瓜常见病害有哪些？如何预防？',
    answer: '黄瓜常见病害主要包括霜霉病、白粉病、枯萎病、灰霉病和细菌性角斑病等。预防措施：选用抗病品种、实行轮作倒茬（与非瓜类作物轮作3年以上）、合理密植改善通风透光、科学水肥管理增强植株抗性、及时清除病残体减少菌源。保护地栽培需注意温湿度调控，降低病害发生风险。',
  },
  {
    id: 'faq-3',
    question: '黄瓜施肥有什么讲究？',
    answer: '黄瓜是喜肥作物，施肥应遵循"基肥为主、追肥为辅，有机肥为主、化肥为辅"的原则。基肥每亩施腐熟有机肥3000-4000公斤加复合肥50公斤。追肥采用"少量多次"方式：定植后追提苗肥（氮肥为主），结瓜初期追催瓜肥（高钾复合肥），盛瓜期每7-10天追肥一次。同时注意补充钙、硼等中微量元素，可有效防止畸形瓜和苦味瓜。',
  },
  {
    id: 'faq-4',
    question: '当前黄瓜批发价格大概多少？',
    answer: '黄瓜批发价格受季节、产区和品质影响波动较大。夏季露地黄瓜集中上市期（7-8月），普通黄瓜批发价约2.0-3.0元/公斤；春秋保护地黄瓜约3.0-5.0元/公斤；冬季温室黄瓜约4.0-7.0元/公斤。水果黄瓜（小黄瓜）价格通常比普通黄瓜高出一倍以上。具体价格建议关注我们每周更新的市场行情栏目。',
  },
  {
    id: 'faq-5',
    question: '如何挑选优质黄瓜种子？',
    answer: '选购黄瓜种子的关键要点：首先看包装标识是否齐全，包括品种名称、审定编号、质量指标（纯度≥95%、净度≥99%、发芽率≥90%）、生产日期和保质期等。其次根据栽培条件选择合适品种，如保护地栽培选择耐低温弱光品种，露地栽培选择抗病耐热品种。最后选择信誉好的品牌，推荐到正规种子门店购买。',
  },
  {
    id: 'faq-6',
    question: '黄瓜可以连作吗？',
    answer: '黄瓜是忌连作作物，连作会导致土传病害加重（如枯萎病、根结线虫病）、土壤养分失衡和自毒物质积累，严重影响产量和品质。一般要求与非瓜类作物轮作3-5年以上。如果确实需要连作，建议采取以下措施：选用抗病品种、嫁接栽培（以黑籽南瓜或白籽南瓜为砧木）、土壤消毒处理、增施生物有机肥等。',
  },
];